import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const PLAN_FETCH_REQUEST = 'PLAN_FETCH_REQUEST'
export const PLAN_FETCH_SUCCESS = 'PLAN_FETCH_SUCCESS'
export const PLAN_FETCH_FAILURE = 'PLAN_FETCH_FAILURE'
export const PLAN_CLEAR = 'PLAN_CLEAR'

const normalizarPlanos = planos => {
  if (!Array.isArray(planos)) {
    return []
  }

  return planos.map(item => ({
    id: item.id,
    numeroPlano: item.numeroPlano,
    titulo: item.titulo,
    tipoPlano: item.tipoPlano,
    ciclo: 'plan',
    status: item.statusPlan,
    dataCriacao: item.dataCriacao,
    resumoCurto: item.resumoCurto,
    impacto: item.impacto,
    diasParaAtrasoCritico: item.diasParaAtrasoCritico,
    lojaNome: item.lojaNome,
    produtoNome: item.produtoNome
  }))
}

export const fetchPlan = ({ empresaId, projetoId, idiomaId, dataInicial, dataFinal }) => {
  return async dispatch => {
    dispatch({ type: PLAN_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/listaplanos', {
        empresaId,
        projetoId,
        idiomaId,
        tipoPlano: '',
        ciclo: 'plan',
        dataInicial,
        dataFinal
      })

      const data = response?.data
      const planos = normalizarPlanos(data?.planos)

      dispatch({
        type: PLAN_FETCH_SUCCESS,
        payload: {
          itens: planos,
          total: planos.length,
          filtros: {
            dataInicial,
            dataFinal
          }
        }
      })
    } catch (error) {
      dispatch({
        type: PLAN_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar planos.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearPlan = () => ({
  type: PLAN_CLEAR
})